<template>
	<div>{{ $t('pagination', { currentPage: currentPage, maxPage: Math.max(currentPage, lastPage), total: total }) }}</div>
</template>
<script>
export default {
	name: 'PaginationNumberOfPages',
	props: {
		currentPage: {},
		lastPage: {},
		total: {},
	},
};
</script>
